export const convertDates = {
  methods: {
    convertDate(tmpdate) {
      
    if (tmpdate) {
        if (tmpdate.length <= 10) {
          var monarray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
          var date = tmpdate.substring(8, 10)
          var year = tmpdate.substring(0, 4)
          var month = parseInt(tmpdate.substring(5, 7))
          if (month <= 12) {
            var newmonth = monarray[month - 1]
            var newdate = date + "-" + newmonth + "-" + year
            return newdate
          } else {
            return tmpdate
          }
        } else {
          return tmpdate
        }
      } else {
        return tmpdate
      }
    }, //end of convertDate
    convertmobile(tmpmobilenumber) {
     
      if (tmpmobilenumber) {
        var newmobilenumber = tmpmobilenumber.substring(0, 5) + " " + tmpmobilenumber.substring(5, 10)
        return newmobilenumber
      } else {
        return tmpmobilenumber
      }
    }, // end of convertmobile
  }, // end of methods
}
